import { createContextLocalStore } from '@/stores/local/createContextLocalStore';

import { OrganizationChatAiPageStore } from './OrganizationChatAiPageStore';

export * from './OrganizationChatAiPageStore';

export const { Provider: OrganizationChatAiPageStoreProvider, useStore: useOrganizationChatAiPageStore } =
  createContextLocalStore(OrganizationChatAiPageStore);
